import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	FETCH_MAINTENANCES_REQUEST,
	FETCH_MAINTENANCES_SUCCESS,
	FETCH_MAINTENANCES_FAIL,
	UPDATE_MAINTENANCE_REQUEST,
	UPDATE_MAINTENANCE_SUCCESS,
	UPDATE_MAINTENANCE_FAIL,
	FETCH_MAINTENANCE_REQUEST,
	FETCH_MAINTENANCE_SUCCESS,
	FETCH_MAINTENANCE_FAIL,
	CREATE_MAINTENANCE_REQUEST,
	CREATE_MAINTENANCE_SUCCESS,
	CREATE_MAINTENANCE_FAIL,
	DELETE_MAINTENANCE_REQUEST,
	DELETE_MAINTENANCE_SUCCESS,
	DELETE_MAINTENANCE_FAIL,
} from "../constants/maintenance";

const fetchMaintenances = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_MAINTENANCES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/maintenances", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		dispatch({
			type: FETCH_MAINTENANCES_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_MAINTENANCES_FAIL, payload: errorMessage });
	}
};

const updateMaintenance = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_MAINTENANCE_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/maintenances/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_MAINTENANCE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_MAINTENANCE_FAIL, payload: errorMessage });
	}
};

const fetchMaintenance = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_MAINTENANCE_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/maintenances/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_MAINTENANCE_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_MAINTENANCE_FAIL, payload: errorMessage });
	}
};

const createMaintenance = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: CREATE_MAINTENANCE_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/maintenances", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchMaintenances({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_MAINTENANCE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_MAINTENANCE_FAIL, payload: errorMessage });
	}
};

const deleteMaintenance = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_MAINTENANCE_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/maintenances/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_MAINTENANCE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_MAINTENANCE_FAIL, payload: errorMessage });
	}
};

export {
	fetchMaintenances,
	updateMaintenance,
	fetchMaintenance,
	createMaintenance,
	deleteMaintenance,
};
